import { planTypes } from '@/common/constants';

const planType = planTypes.CONCURRENT_MEETING_BASIC;

export default {
  key: planTypes[planType],
  data() {
    return {
      planType,
      title: this.$t('billing.concurrent_meeting_basic.title'),
      logo: require('@/assets/plans/concurrent-meeting-basic.svg'),
    };
  },
};